import offerImage from '../../../../assets/images/bplusNewDevicePromotionBannerImg.svg';
import gotoEasyBuyArrow from '../../../../assets/images/bplusNewDevicePromotionBannerDownarrow.svg';
import './BPlusNewDevicePromotionBanner.css';
import EcoProButton from "../../../../components/shared/button/button";
import { getLocalSessionData, getUserDataByKey } from "../../../../utils/Authentication/handleUserSession";
import { useTranslation } from "react-i18next";
import { LOCALSESSIONDATAKEYS } from "../../../../constants/AppConstants";
import { useDispatch } from "react-redux";
import { getNewDevicePromoCodeRequest } from "../../../../store/brotherPlus/GetNewDevicePromoCode/getNewDevicePromoCodeSlice";

const BPlusNewDevicePromotionBanner = ({ onNewDevicePromotionBannerClick }) => {
    const firstName = getUserDataByKey('firstName', 'personal_details')
    const userId = getLocalSessionData(LOCALSESSIONDATAKEYS.UID)
    const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID)
    const { t } = useTranslation(["translation"]);
    const dispatch = useDispatch();
    const goToEasyBuy = () => {
        document.getElementsByClassName('easy-buy-container')[0]?.scrollIntoView({ behavior: 'smooth' });
    }
    const handleClick = () => {
        goToEasyBuy();
        dispatch(getNewDevicePromoCodeRequest({ userId, deviceId }));
        onNewDevicePromotionBannerClick();
    }

    return (
        <div className="bplus-new-device-promotion-banner-wrapper">
            <div className="image-wrapper">
                <img src={offerImage} alt="promotion-banner" title="promotion-banner" />
            </div>
            <div className="content-wrapper">
                <h5 className="title">{t("NEW_DEVICE_PROMOTION_BANNER.WELCOME", { firstName: firstName })}</h5>
                <p className="caption">{t("NEW_DEVICE_PROMOTION_BANNER.CAPTION")}</p>
                <EcoProButton cname="default, order-now-btn" onBtnClick={() => handleClick()}>
                    <span>{t("NEW_DEVICE_PROMOTION_BANNER.ORDER_INK")}</span>
                    <img src={gotoEasyBuyArrow} alt='go-to-easybuy' title='go-to-easybuy' />
                </EcoProButton>
            </div>
        </div>
    )
}

export default BPlusNewDevicePromotionBanner;